module.exports = __webpack_public_path__ + "static/media/pic14.ae7fafdd.jpg";